const emailItem = [
  { to: "inbox", name: "Inbox" },
  { to: "readMail", name: "Read Email" },
];

export default emailItem;
